import { StoryChapterThumbnail } from '../../models/story-chapter-thumbnail.model';

export class StoryThumbnailsStateModel {
  thumbnails: Map<string, StoryChapterThumbnail>;
}
